<template>
  <Teleport to="body">
    <Modal
      v-if="downloadsModalOpen"
      @close="
        () => {
          downloadsModalOpen = false
        }
      "
    >
      <ul class="tw-m-0 tw-p-0">
        <li v-for="download in selectedDownloads" class="tw-m-0">
          <a
            :href="download?.download_file?.url"
            class="tw-text-[#d53410] tw-cursor-pointer"
            target="_blank"
          >
            {{ download.download_file?.name }}
          </a>
        </li>
      </ul>
    </Modal>
  </Teleport>
  <section class="reso reso-events mt50">
    <header class="jwb-header">
      <h2 class="m0 tw-text-center">Public Meetings & Events</h2>
    </header>

    <!-- Desktop View -->
    <div class="container mt75 mmt75 mb75 mmb75 hide-mobile table-container">
      <template v-for="eventHeadline in eventYearArray" :key="eventHeadline">
        <h3 class="orange bold text-left table-headline">
          {{ eventHeadline }}
        </h3>
        <div class="table-responsive bg-white m-mb50">
          <table class="table">
            <tbody>
              <tr
                v-for="event in getEventsForHeading(eventHeadline)"
                :key="event.id"
                class="d-flex"
              >
                <td class="col-sm-3 align-top">
                  <p class="m0 black bold">{{ event.date }}</p>
                  <p class="m0 black">{{ event.time }} EST</p>
                </td>
                <td class="col-sm-4 align-top">
                  <a :href="event.link" class="m0 orange">
                    {{ event.title }}
                    <span class="spacer-hide"
                      >spacer hide hide spacer hide</span
                    >
                  </a>
                </td>
                <td class="col-sm-5 align-top">
                  <a
                    v-if="event.mapLink"
                    :href="event.mapLink"
                    class="m0 orange"
                    target="_blank"
                  >
                    {{ event.venue }}
                  </a>
                  <a
                    v-else-if="event.website"
                    :href="event.website"
                    class="m0 orange"
                    target="_blank"
                  >
                    {{ event.venue }}
                  </a>
                  <span v-else-if="event.venue" class="m0 orange">
                    {{ event.venue }}
                  </span>
                </td>
                <td>
                  <div class="tw-min-w-[80px]">
                    <span
                      v-if="event?.downloads?.length > 0"
                      class="tw-m-0 tw-text-[#d53410] tw-cursor-pointer"
                      @click="
                        () => {
                          downloadsModalOpen = true
                          selectedDownloads = event.downloads
                        }
                      "
                      >Download
                    </span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </template>
    </div>

    <!-- Mobile View -->
    <div class="container mt75 mmt75 mb75 mmb75 hide-desktop mobile-events">
      <template v-for="eventHeadline in eventYearArray" :key="eventHeadline">
        <h3 class="orange bold text-left table-headline">
          {{ eventHeadline }}
        </h3>

        <div
          v-for="event in getEventsForHeading(eventHeadline)"
          :key="event.id"
          class="mobile-event"
        >
          <p class="m0 black bold">{{ event.date }}</p>
          <p class="m0 black">{{ event.time }}</p>
          <div class="mmb10">
            <a :href="event.link" class="m0 orange">{{ event.title }}</a>
          </div>
          <a
            v-if="event.mapLink"
            :href="event.mapLink"
            class="m0 orange"
            target="_blank"
          >
            {{ event.venue }}
          </a>
        </div>
      </template>
    </div>
  </section>
</template>

<script setup>
import Modal from '~/components/Modal.vue'
import { defineProps, ref } from 'vue'

const downloadsModalOpen = ref(false)
const selectedDownloads = ref([])

const props = defineProps({
  eventYearArray: {
    type: Array,
    required: true,
  },
  events: {
    type: Array,
    required: true,
  },
})

const getEventsForHeading = (heading) => {
  return props.events.filter((event) => event.heading === heading)
}
</script>
